import { Component } from '@angular/core';
import { SharedService } from '@shared/services/shared.service';

@Component({
  selector: 'app-pay-online-duplicate',
  templateUrl: './pay-online-duplicate.component.html'
})

export class PayOnlineDuplicateComponent {

  public processing: boolean = false;
  public isValid: boolean = true;

  constructor(public sharedService: SharedService) { }
}


